import { Field } from 'Util/Query';

export default class InpostPayQuery {
    getInpostPayConfig() {
        return new Field('storeConfig')
            .addFieldList(this.getConfigFields());
    }

    getConfigFields() {
        return [
            'inpost_pay_widget_enabled',
            'inpost_pay_show_on_success_page',
            'inpost_pay_show_on_register_page',
            'inpost_pay_show_on_product_cart',
            'inpost_pay_show_on_login_page',
            'inpost_pay_show_on_checkout_page',
            'inpost_pay_show_on_cart',
            'inpost_pay_show_in_minicart',
            'inpost_pay_widget_styles',
        ]
    }

    createInpostBasket(cartId) {
        return new Field('inPostPayInitBasket')
            .addArgument('cart_id', 'String!', cartId)
            .addFieldList(this.getInpostBasketFields());
    }


    getInpostBasketFields() {
        return [
            'basket_binding_api_key',
            'error',
            'success'
        ]
    }

    getInpostPlaceOrderData(basketId) {
        return new Field('inPostPayGetPlacedOrderData')
            .addArgument('basket_binding_api_key', 'String!', basketId)
            .addFieldList(this.getInpostPlaceOrderDataFields());
    }

    getInpostPlaceOrderDataFields() {
        return [
            'error',
            'increment_id',
            'redirect',
            'success'
        ]
    }
}
